const OWNED_JSON_LD_SELECTOR = 'script[type="application/ld+json"][data-seo-json-ld="true"]';

/** Serialize structured data for an inline script without allowing a value to close the element. */
export function serializeJsonLd(jsonLd: object | object[] | undefined): string | undefined {
	return jsonLd === undefined ? undefined : JSON.stringify(jsonLd).replace(/</g, "\\u003c");
}

/**
 * Keep one current Seo-owned JSON-LD script in the document head.
 *
 * react-helmet-async keys inline scripts by their full contents. During hydration, the pre-rendered
 * locale and a post-mount reading-language override can briefly remain as separate Helmet instances,
 * so Helmet preserves both scripts instead of replacing the older value. Reconcile only scripts that
 * Seo marks as its own; unrelated structured data remains untouched.
 */
export function synchronizeJsonLdHead(document: Document, serialized: string | undefined): void {
	let current: HTMLScriptElement | undefined;
	for (const script of document.querySelectorAll<HTMLScriptElement>(OWNED_JSON_LD_SELECTOR)) {
		if (serialized !== undefined && current === undefined
			&& script.parentElement === document.head && script.textContent === serialized) {
			current = script;
		} else {
			script.remove();
		}
	}
	if (serialized === undefined || current !== undefined) {
		return;
	}

	const script = document.createElement("script");
	script.type = "application/ld+json";
	script.setAttribute("data-rh", "true");
	script.setAttribute("data-seo-json-ld", "true");
	script.textContent = serialized;
	document.head.appendChild(script);
}
